module.exports = __webpack_public_path__ + "img/7_57.b27133bb.png";